import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

import * as TC from '../styles/Assignment_Styles';

class AssignmentCell extends Component {

    // --- HELPERS ---

    enhancedCell = (props) => {

        // const { classes } = this.props;

        let formatted;

        if (props.column === 'type') {
            const type = props.data.type[0];
            formatted = (
                <TableCell style={TC.getColumnStyle(props.column)}>
                    <Chip
                        style={TC.getTypeStyle(type)}
                        label={type}
                    ></Chip>
                </TableCell>
            )

        } else if (props.column === 'status'){

            const status = props.data.status[0];

            formatted = (
                <TableCell style={TC.getColumnStyle(props.column)}>
                    <Chip
                        style={TC.getStatusStyle(status)}
                        label={status}
                    ></Chip>
                </TableCell>
            )

        } else if (props.column === 'number') {
            const link = props.data.url;
            const linkToDefect= (event) => {
                window.open(event.currentTarget.getAttribute('defectlink'));
            } 
            formatted = (
                <TableCell style={TC.getColumnStyle(props.column)}>
                    <Button defectlink={link} onClick={linkToDefect} style={TC.getLinkButtonStyle()}>
                        {props.data.id}
                    </Button>
                </TableCell>
            )

        } else {

            formatted = (
                <TableCell style={TC.getColumnStyle(props.column)}>
                    {props.data[props.column].id}
                </TableCell>
            )

        }
        return formatted
    }

    // --- RENDER ---

    render() {
        return this.enhancedCell(this.props)
    }
}
const style = {
    updated: {
        background: '#F8F9F9'
    },
    label: {
        whiteSpace: 'pre'
    }
}

AssignmentCell.propTypes = {
    column: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
};

export default withStyles(style)(AssignmentCell);


// WEBPACK FOOTER //
// ./src/js/components/Assignment_Cell.js